<template>
  <div
    class="perk-container flex flex-col justify-between items-start h-44 w-96 shadow-lg rounded-lg p-6 space-y-2 text-white"
    :style="`background-image: url('${getAssetUrl(perk.image)}')`"
  >
    <p class="text-xs uppercase font-semibold">
      {{ perk.title }}
    </p>
    <h4 class="font-bold text-xl leading-6">
      {{ perk.description }}
    </h4>
    <a
      href="https://careers.vetster.com"
      target="_blank"
      rel="noopener noreferrer"
      class="active:bg-bubblegum-700 focus:border-bubblegum-700 focus:ring-bubblegum focus:outline-none inline-flex justify-center items-center border border-transparent rounded-full transition py-2 px-8 text-lg md:text-base font-semibold background-origin-border-box text-black focus:outline-bubblegum-400 bg-bubblegum-500 hover:bg-bubblegum-600 inter"
    >
      {{ $t('about.see-open-roles') }}
    </a>
  </div>
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterPerksSliderTile',

  props: {
    perk: {
      type: Object,
      default: () => ({}),
    },
  },

  methods: {
    getAssetUrl,
  },
};
</script>

<style>
.perk-container {
  background-size: cover;
  background-position: center;
}
</style>
